import type { TransactionRule } from '@carboncopyco/types';
import { Modal, type ModalProps } from '@carboncopyco/ui';
import { getMaxZIndex } from '@carboncopyco/utils';
import { v4 as uuid } from 'uuid';
import { Separator } from '../TransactionRuleModal';
import {
  CreateTransactionRuleProvider,
  type UseCreateTransactionRule,
} from './CreateTransactionRuleContext';
import { CreateTransactionRuleSteps } from './CreateTransactionRuleSteps';
import { CreateTransactionRuleStepsHeader } from './CreateTransactionRuleStepsHeader';

export interface CreateTransactionRuleModalProps
  extends Pick<ModalProps, 'open' | 'onClose'>,
    Pick<
      UseCreateTransactionRule,
      | 'transactions'
      | 'transactionModifications'
      | 'onLearnMoreClick'
      | 'isVisualSearch'
      | 'cancelVisualSearch'
    > {
  onSubmit: (
    transactionRule: TransactionRule,
    refresh?: boolean
  ) => Promise<unknown>;
}

export const CreateTransactionRuleModal = ({
  open,
  onClose,
  onSubmit,
  onLearnMoreClick,
  transactionModifications,
  transactions,
  isVisualSearch,
  cancelVisualSearch,
}: CreateTransactionRuleModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      floatingCloseButton
      noPadding
      closeOnlyFromCloseIcon
      zIndex={getMaxZIndex() + 1}
    >
      <CreateTransactionRuleProvider
        onLearnMoreClick={onLearnMoreClick}
        transactions={transactions}
        transactionModifications={transactionModifications}
        cancelCreation={onClose}
        submitCreation={(transactionRule, shouldRefresh) =>
          onSubmit(
            {
              id: uuid(),
              name: transactionRule.name.trim(),
              description: transactionRule.description,
              rules: [
                {
                  id: uuid(),
                  selectors: transactionRule.selectors,
                  modifiers: transactionRule.modifiers,
                },
              ],
            },
            shouldRefresh
          )
        }
        isVisualSearch={isVisualSearch}
        cancelVisualSearch={cancelVisualSearch}
      >
        <CreateTransactionRuleStepsHeader />
        <Separator />
        <div className="w-ds-lg-modal h-[656px]">
          <CreateTransactionRuleSteps />
        </div>
      </CreateTransactionRuleProvider>
    </Modal>
  );
};
